import { languageIntlFormats } from "@/i18n";

import numbro from "numbro";
// @ts-ignore
import * as numbroLanguages from "numbro/dist/languages.min";
import { Customer } from "server/dwhApi/customers/types.js";

import { GraphData } from "./chart";
import {
  getBestPositionData,
  getCurrentPositionData,
  getOrganizedCustomerData,
  getPositionBehindData,
  getPositionInFrontData,
} from "./utils";

export const getChartData = ({
  tenantsData,
  comparisonOption,
  currentTenant,
  language = "",
}: {
  tenantsData: Customer[];
  comparisonOption: string;
  currentTenant?: Customer;
  language?: string;
}) => {
  const currentTenantData = tenantsData.find(
    (customer) => customer.customerId === currentTenant?.customerId,
  );
  if (!currentTenant || !currentTenantData) {
    return [];
  }

  if (language && numbroLanguages[language]) {
    numbro.registerLanguage(numbroLanguages[language]);
    numbro.setLanguage(languageIntlFormats[language]);
  }

  const { commercialCustomerCategory } = currentTenantData;

  const sortedGroupedCustomers = getOrganizedCustomerData({
    tenantsData,
    comparisonOption,
    commercialCustomerCategory,
  });

  const data: GraphData[] = [];

  // add data for best tenant
  const bestTenant = getBestPositionData({
    sortedGroupedCustomers,
    currentTenant,
  });
  data.push(bestTenant);

  // add tenant in front if exists and is not best tenant
  const positionInFront = getPositionInFrontData({
    sortedGroupedCustomers,
    currentTenant,
  });
  if (positionInFront) {
    data.push(positionInFront);
  }

  // add current tenant if not best
  const currentTenantPosition = getCurrentPositionData({
    sortedGroupedCustomers,
    currentTenant,
  });
  if (currentTenantPosition) {
    data.push(currentTenantPosition);
  }

  // add tenant behind if exists
  const positionBehind = getPositionBehindData({
    sortedGroupedCustomers,
    currentTenant,
  });
  if (positionBehind) {
    data.push(positionBehind);
  }

  return data;
};
